import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'react-table';
import { Table } from '@components/Common';
import { BookkeepingEntry } from '@api/queries/inventory';
import {
  getAmountColumn,
  getDirectionColumn,
  getEntryStateColumn,
  getEntryTypeColumn,
  getShipmentTypeColumn,
  getUnloadingFinishedColumn,
} from '../Common/entryColumns';

interface Props {
  entries: BookkeepingEntry[];
  billedEntryIds: Set<string>;
}

const BillingTable: React.FC<Props> = ({ entries, billedEntryIds }) => {
  const { t } = useTranslation();

  const columns: Column[] = useMemo(
    () => [
      {
        Header: 'Id',
        id: 'id',
        accessor: 'id',
        show: false,
      },
      getEntryStateColumn(t),
      getAmountColumn(t),
      getDirectionColumn(t),
      getUnloadingFinishedColumn(t),
      getEntryTypeColumn(t),
      getShipmentTypeColumn(t),
      {
        Header: t('reports.carrier_information'),
        id: 'carrierInformation',
        accessor: 'carrierInformation',
      },
      {
        Header: t('entry.isBilled'),
        id: 'isBilled',
        accessor: (entry: BookkeepingEntry) =>
          billedEntryIds.has(entry.id) ? t('billing.billed') : t('billing.not_billed'),
      },
      {
        Header: t('entry.notes'),
        id: 'notes',
        accessor: 'notes',
      },
      {
        Header: t('entry.billing'),
        id: 'billingInformation',
        accessor: 'billingInformation',
      },
    ],
    [t, billedEntryIds]
  );

  return (
    <Table
      data={entries}
      columns={columns}
      filterable={false}
      defaultSortColumn="unloadingFinished"
      defaultSortDesc={true}
      defaultPageSize={20}
      noDataText={t('entry.no_rows_bookkeeping_invoicing')}
    />
  );
};

export default BillingTable;
